import { render, staticRenderFns } from "./Welcome.vue?vue&type=template&id=e56f2726&scoped=true&"
import script from "./Welcome.vue?vue&type=script&lang=js&"
export * from "./Welcome.vue?vue&type=script&lang=js&"
import style0 from "./Welcome.vue?vue&type=style&index=0&id=e56f2726&scoped=true&lang=css&"
import style1 from "./Welcome.vue?vue&type=style&index=1&id=e56f2726&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e56f2726",
  null
  
)

component.options.__file = "Welcome.vue"
export default component.exports